module.exports = require("lodash/flatMap");